import React, {useEffect, useRef, useState} from "react";
import {Bell as BellIcon} from "react-feather";
import {useIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {Link as RouterLink} from "react-router-dom";

import {
  Avatar,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
  SvgIcon,
  Tooltip,
  Typography,
  makeStyles
} from "@material-ui/core";

import useLocale from "src/hooks/useLocale";

import {searchNotifications} from "src/actions/notificationsActions";

const useStyles = makeStyles((theme) => ({
  popover: {
    width: 350
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    marginRight: "10px"
  },
  noti: {
    alignItems: "initial"
  },
  noMargin: {
    margin: 0
  },
  list: {
    maxHeight: "calc(60vh)",
    overflowX: "hidden",
    overflowY: "auto"
  }
}));

function Notifications() {
  const classes = useStyles();
  const {formatMessage} = useIntl();
  const {renderContentByLangType2, calcRelativeNotifyTime} = useLocale();
  const {notifications} = useSelector((state) => state.notifications);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    dispatch(
      searchNotifications({
        user_id: userId
      })
    );
  }, [dispatch]);

  return (
    <>
      <Tooltip
        title={formatMessage({
          id: "topBar-notification-XpSTh",
          defaultMessage: "Notification",
          description: ""
        })}
      >
        <IconButton color="inherit" ref={ref} onClick={handleOpen}>
          <SvgIcon>
            <BellIcon />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <Popover
        classes={{paper: classes.popover}}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <Box p={2}>
          <Typography variant="h4" color="textPrimary">
            {formatMessage({
              id: "topBar-notification-XpSTh",
              defaultMessage: "Notification",
              description: ""
            })}
            {/* Notification */}
          </Typography>
        </Box>
        {notifications.length === 0 ? (
          <Box p={2}>
            <Typography variant="h6" color="textPrimary">
              {formatMessage({
                id: "topBar-notification-RtpNc",
                defaultMessage: "There are no notifications!",
                description: ""
              })}
              {/* There are no notifications */}
            </Typography>
          </Box>
        ) : (
          <div>
            <List className={classes.list} disablePadding>
              {notifications.map((notification, index) => (
                <ListItem
                  className={classes.noti}
                  component={RouterLink}
                  divider
                  key={notification.id}
                  to="#"
                >
                  <Avatar
                    className={classes.icon}
                    alt={`Noti No.${index + 1}'s icon`}
                    src="https://jx-central-media-stg.s3.amazonaws.com/centralweb/64027cf4-8e98-45f8-8cfd-ced37681af29/image/859095-116006833657412.png"
                  />
                  <div>
                    <ListItemText
                      primary={renderContentByLangType2(notification, "content")}
                      primaryTypographyProps={{
                        variant: "subtitle2",
                        color: "textPrimary"
                      }}
                      className={classes.noMargin}
                    />
                    <Typography>
                      {calcRelativeNotifyTime(notification.created_at)}
                    </Typography>
                  </div>
                </ListItem>
              ))}
            </List>
            <Box p={1} display="flex" justifyContent="center">
              <Button
                component={RouterLink}
                size="small"
                to="#"
                color="primary"
                variant="outlined"
              >
                {formatMessage({
                  id: "topBar-notification-EydpR",
                  defaultMessage: "Mark all as read",
                  description: ""
                })}
                {/* Mark all as read */}
              </Button>
            </Box>
          </div>
        )}
      </Popover>
    </>
  );
}

export default Notifications;
